export const eventBus = new sVue()
window.eventBus = eventBus
